import React, { useState } from 'react'
import { FancyModal } from '@deal/components'
import { generateCreateUrlFromCategory } from '#src/services/path'
import { SellableBrandCategoryComponent } from '#src/generated/graphql'
import V1 from './v1'
import V2 from './v2'
import config from '#src/config'
import cookies from 'js-cookie'
import styles from './styles.css'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'

interface CategoryModalProps {
  sellableId?: string
  categorySlug: string
  variation: 'v1' | 'v2'
}

const CategoryModal: React.SFC<CategoryModalProps & WithAnalyticsProps> = ({
  sellableId,
  analytics,
  variation,
  categorySlug
}) => {
  if (!sellableId) {
    return null
  }

  const [isModalOpen, setIsModalOpen] = useState(true)

  const onDismissClick = () => {
    cookies.set('category_modal_viewed', 'true', {
      expires: 1,
      domain: config.get('consumer.clientSideCookieDomain')
    })

    if (analytics) {
      analytics.events.engagementChannelDismissed({
        engagement_channel: 'category-modal-dual-headline',
        variation,
        category: categorySlug
      })
    }

    setIsModalOpen(false)
  }

  if (cookies.get('category_modal_viewed')) {
    return null
  }

  return (
    <FancyModal
      overlayClassName={styles.overlayClass}
      className={styles.modalClass}
      isOpen={isModalOpen}
      onRequestClose={onDismissClick}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <SellableBrandCategoryComponent
        variables={{
          friendlyIdOrId: sellableId
        }}
      >
        {({ data }) => {
          if (
            data &&
            data.findSellable &&
            data.findSellable.brand &&
            data.findSellable.categories.length
          ) {
            const category = data.findSellable.categories[0]
            const pathCategory = category.ancestorWithPath && category.ancestorWithPath.slug
            const pathUrl = generateCreateUrlFromCategory({
              maybeCategorySlug: pathCategory,
              pathIntent: 'request',
              sourceKey: 'category-modal-engagement-channel'
            })

            const brandName = data.findSellable.brand.displayName

            if (variation === 'v1') {
              return <V1 brandName={brandName} pathUrl={pathUrl} category={category} />
            } else {
              return <V2 brandName={brandName} pathUrl={pathUrl} category={category} />
            }
          }
          return null
        }}
      </SellableBrandCategoryComponent>
    </FancyModal>
  )
}

export default withAnalytics(CategoryModal)
